<template>
  <div class="event-edit-container"
    :class="containerClass">
    <ul class="topnav">
      <router-link v-for="(route, i) in routes" :key="i"
        :to="{ name: route.id }" :event="isNavigationDisabled ? '' : 'click'"
        :class="{ 'disabled-route': isNavigationDisabled }">
        <li>{{route.title}}</li>
      </router-link>
    </ul>
    <div class="content">
      <router-view @next="fromRoute => goNext(fromRoute)"></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'event-edit',
  data() {
    return {
      routes: [{
        id: 'event-overview',
        path: 'overview',
        title: 'Overview',
      }, {
        id: 'event-pitch',
        path: 'pitch',
        title: 'Pitch',
      }, {
        id: 'event-pricing',
        path: 'pricing',
        title: 'Pricing',
      }, {
        id: 'event-market-trend',
        path: 'market',
        title: 'Market',
      }, {
        id: 'event-team',
        path: 'team',
        title: 'Invite',
      }, {
        id: 'event-preview',
        path: 'preview',
        title: 'Preview',
      }],
      isNew: true,
      isEditable: true,
    };
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.isNew = (newVal.params.eventId === 'new');
        try {
          if (this.isNew) {
            const response = await this.backendAxios
              .post('/sponsorship-event/my-event/');
            const eventId = response.data;
            this.$router.replace({ name: 'event-overview', params: { eventId } });
          }
        } catch (err) {
          this.$toasted.show(err.response.data, {
            type: 'info',
            duration: 5000,
          });
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.isEditable = true;
    if (!this.isNew) {
      const role = await this.fetchEventRole({ eventId: this.$route.params.eventId });
      const status = await this.fetchEventStatus({ eventId: this.$route.params.eventId });
      this.isEditable = this.canEditEvent(role, status);
      if (!this.isEditable) {
        this.$router.push('preview');
      }
    }
  },
  computed: {
    ...mapGetters('sponsorshipEvent', ['canEditEvent']),
    ...mapState('auth', ['backendAxios']),
    isNavigationDisabled() {
      return this.isNew || !this.isEditable;
    },
    containerClass() {
      return this.$route.name === 'event-preview' ? 'preview' : 'not-preview';
    },
  },
  methods: {
    ...mapActions('sponsorshipEvent', ['fetchEventRole', 'fetchEventStatus']),
    goNext(fromRoute) {
      const matchingRouteIndex = this.routes.findIndex(route => route.id === fromRoute);
      if (matchingRouteIndex < 0 || matchingRouteIndex >= this.routes.length - 1) {
        this.$toasted.show('No matching route found', {
          type: 'info',
          duration: 5000,
        });
      } else {
        const nextRoute = this.routes[matchingRouteIndex + 1];
        this.$router.push(`/event/${this.$route.params.eventId}/edit/${nextRoute.path}`);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.topnav {
  display: flex;
  justify-content: flex-start;
  overflow-x: scroll;
  list-style-type: none;
  line-height: 1;
  margin: 1rem 0 0 0;
  padding-left: 0;
}

.topnav li {
  cursor: pointer;
  padding-bottom: 1rem;
  font-size: 1rem;
}

.topnav a {
  float: left;
  color: #333333;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
}

.content {
  padding: 1rem;
  border-radius: 0.35rem;
}

.router-link-active li {
  padding-bottom: 0.5rem;
  border-bottom: 0.15rem solid $router-link;
  font-weight: 500;
}

</style>

<style lang="scss">
@import '@/assets/youpaired-colors.scss';

.event-edit-container {
  margin: 0 auto 2rem auto;
}

.not-preview {
  width: 70%;
}

.preview {
  width: 100%;
  padding: 0.5rem 0;
}

.preview .topnav {
  width: 70%;
  margin: 0 auto;
  padding: 0.5rem 0;
}

@media screen and (max-width: 811px) {
  .not-preview {
    width: 100%;
  }

  .preview .topnav {
    width: 100%;
    padding: 0.5rem 0;
  }

  .topnav{
    border-bottom: 1px solid lightgray;
  }
}

.disabled-route {
  color: gray !important;
}

</style>
